// @ts-strict-ignore
import type { WorkflowProps } from 'flow/store/engine/types';
import type { SetWhatIfDisabledReasons } from '~/flow/TestingSuite/pages/SelectDataType/utils';
import { WHAT_IF_ELIGIBLE_WORKFLOW_TYPES } from './constants';
import type { TSuiteBufferItem } from '../changelog/formatters/testingSuiteFormatter/types';

export function getIsChampionChallengerEnabled(opts: {
  championChallengerStarted: string;
  championChallengerEnded: string;
}): boolean {
  if (!opts) {
    return false;
  }
  const {
    championChallengerEnded = null,
    championChallengerStarted = null,
  } = opts;
  return (
    championChallengerStarted && (championChallengerEnded == null)
  );
}


export function shouldDisableWhatIf(args: {
  // todo BUILD-1598 - use a type that doesn't expose the buffer's internals
  changes: Record<string, TSuiteBufferItem>;
  isHistoricalDataAvailable?: { baseVersion?: boolean; otherVersions?: boolean };
  workflowType: string;
  setWhatIfDisabledReasons: SetWhatIfDisabledReasons;
}) {
  const {
    changes, isHistoricalDataAvailable, workflowType, setWhatIfDisabledReasons,
  } = args;
  const {
    setIsWhatIfDisabledByWorkflowType,
    setIsWhatIfDisabledByChanges,
    setIsWhatIfDisabledByBaseData,
    setIsWhatIfDisabledByOtherData,
  } = setWhatIfDisabledReasons;

  // What if can only be run for a subset of workflow types
  const isWorkflowTypeEligible = WHAT_IF_ELIGIBLE_WORKFLOW_TYPES.includes(workflowType);
  if (!isWorkflowTypeEligible) {
    setIsWhatIfDisabledByWorkflowType(true);
    return true;
  }

  const hasChanges = Object.values(changes).length > 0;
  if (!hasChanges) {
    setIsWhatIfDisabledByOtherData(!isHistoricalDataAvailable?.otherVersions);
    return !isHistoricalDataAvailable?.otherVersions;
  }

  const hasIneligibleChanges = Object.values(changes)
    .some(changesForAction => changesForAction.containsIneligible);
  setIsWhatIfDisabledByChanges(hasIneligibleChanges);
  setIsWhatIfDisabledByBaseData(!isHistoricalDataAvailable?.baseVersion);
  return hasIneligibleChanges || !isHistoricalDataAvailable?.baseVersion;
}


export function doesWorkflowTypeSupportTestingSuite(
  workflowType: WorkflowProps['workflow']['type'],
) {
  return workflowType !== 'router';
}
